module.exports = __webpack_public_path__ + "img/zan.5a6468dd.png";